import { Routes } from '@angular/router';
import { TemplateComponent } from './components/organisms/template/template.component';
import { LoginComponent } from './components/organisms/login/login.component';
import { SelectTemplateComponent } from './components/organisms/select-template/select-template.component';
import { EditSendoutComponent } from './components/organisms/edit-sendout/edit-sendout.component';
import { OverviewComponent } from './components/organisms/overview/overview.component';
import { EmailSendoutComponent } from './components/organisms/email-sendout/email-sendout.component';
import { EmailSendoutManagerComponent } from './components/organisms/email-sendout-manager/email-sendout-manager.component';
import { SelectEventComponent } from './components/organisms/select-event/select-event.component';
import { TemplatesComponent } from './components/organisms/templates/templates.component';
import { StoreLoginComponent } from './components/organisms/store-login/store-login.component';
import { AdvisorSessionExpiredComponent } from './components/organisms/advisor-session-expired/advisor-session-expired.component';
import { AuthGuard } from './guards/auth/auth.guard';
import { AccessUnavailableComponent, NoAccessComponent } from './components/organisms/no-access/no-access.component';
import { SelectStoreComponent } from './components/organisms/select-store/select-store.component';
import { NotFoundPageComponent } from './components/organisms/not-found-page/not-found-page.component';
import { ManageCalendarItemsComponent } from './components/organisms/manage-calendar-items/manage-calendar-items.component';
import { ManageStoresComponent, manageStoresCanDeactivate } from './components/organisms/manage-stores/manage-stores.component';
import { EditMultiStoreSendoutComponent } from './components/organisms/edit-multi-store-sendout/edit-multi-store-sendout.component';
import { MemberLookupPageComponent } from './components/organisms/member-lookup-page/member-lookup-page.component';
import { ManageUsersComponent, manageUsersCanDeactivate } from './components/organisms/manage-users/manage-users.component';
import { administrationGuard } from './guards/administration/administration.guard';
import { StoreDetailComponent, storeDetailCanDeactivate } from './components/organisms/store-detail/store-detail.component';
export const routes: Routes = [
  {
    path: 'landing',
    component: NoAccessComponent,
    data: { permission: 'landing' },
    canActivate: [AuthGuard, administrationGuard],
  },
  {
    path: 'no-access',
    component: NoAccessComponent,
    title: 'Ingen adgang',
    data: { permission: 'no-access' },
    canActivate: [AuthGuard, administrationGuard],
  },
  {
    path: 'access-unavailable',
    component: AccessUnavailableComponent,
    title: 'Adgang kunne ikke kontrolleres',
    canActivate: [AuthGuard],
  },
  {
    path: 'select-store',
    component: SelectStoreComponent,
    title: 'Vælg butik',
    data: { permission: 'select-store' },
    canActivate: [AuthGuard, administrationGuard],
  },
  {
    path: 'advisor-session-expired',
    component: AdvisorSessionExpiredComponent,
    title: 'Session udløbet',
    pathMatch: 'full',
  },
  {
    path: '',
    component: LoginComponent,
    title: 'Login',
    pathMatch: 'full',
  },
  {
    path: 'storelogin',
    component: StoreLoginComponent,
    title: 'StoreLogin',
    pathMatch: 'full',
  },
  {
    path: 'overview',
    data: { permission: 'store' },
    canActivate: [AuthGuard, administrationGuard],
    component: OverviewComponent,
    title: 'Overblik',
    pathMatch: 'full',
  },
  {
    path: 'template/:id',
    data: { permission: 'TemplateManager' },
    canActivate: [AuthGuard, administrationGuard],
    component: TemplateComponent,
    title: 'Template',
    pathMatch: 'full',
  },
  {
    path: 'templates',
    data: { permission: 'TemplateManager' },
    canActivate: [AuthGuard, administrationGuard],
    component: TemplatesComponent,
    title: 'Templates',
    pathMatch: 'full',
  },
  {
    path: 'store-sendouts',
    data: { permission: 'store' },
    canActivate: [AuthGuard, administrationGuard],
    component: EmailSendoutComponent,
    title: 'Udsendelser',
    pathMatch: 'full',
  },
  {
    path: 'sendouts',
    data: { permission: 'sendouts' },
    canActivate: [AuthGuard, administrationGuard],
    component: EmailSendoutManagerComponent,
    title: 'Udsendelser',
    pathMatch: 'full',
  },

  {
    path: 'sendout/create',
    redirectTo: 'sendout/create/select-template',
    pathMatch: 'full',
  },
  {
    path: 'sendout/create/select-template',
    data: { permission: 'select-template' },
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    canActivate: [AuthGuard, administrationGuard],
    component: SelectTemplateComponent,
    title: 'Select Templates',
    pathMatch: 'full',
  },
  {
    path: 'sendout/create/select-event',
    data: { permission: 'store' },
    canActivate: [AuthGuard, administrationGuard],
    component: SelectEventComponent,
    title: 'Select event',
    pathMatch: 'full',
  },
  {
    path: 'sendout/new',
    data: { permission: 'store' },
    canActivate: [AuthGuard, administrationGuard],
    component: EditSendoutComponent,
    title: 'New sendout',
    pathMatch: 'full',
  },
  {
    path: 'sendout/new-multi-store',
    data: { permission: 'SendoutManager' },
    canActivate: [AuthGuard, administrationGuard],
    component: EditMultiStoreSendoutComponent,
    title: 'New sendout',
    pathMatch: 'full',
  },
  {
    path: 'sendout/:sendoutId',
    data: { permission: 'sendout' },
    canActivate: [AuthGuard, administrationGuard],
    component: EditSendoutComponent,
    title: 'Edit Sendout',
    pathMatch: 'full',
  },
  {
    path: 'multi-store-sendout/:sendoutId',
    data: { permission: 'SendoutManager' },
    canActivate: [AuthGuard, administrationGuard],
    component: EditMultiStoreSendoutComponent,
    title: 'Edit Sendout',
    pathMatch: 'full',
  },
  {
    path: 'sendout/:sendoutId/select-event',
    data: { permission: 'sendout' },
    canActivate: [AuthGuard, administrationGuard],
    component: SelectEventComponent,
    title: 'Select event',
    pathMatch: 'full',
  },
  {
    path: 'manage-calendar',
    data: { permission: 'SendoutManager' },
    canActivate: [AuthGuard, administrationGuard],
    component: ManageCalendarItemsComponent,
    title: 'Manage calendar',
    pathMatch: 'full',
  },
  {
    path: 'manage-stores',
    data: { permission: 'StoreManager' },
    canActivate: [AuthGuard, administrationGuard],
    component: ManageStoresComponent,
    title: 'Manage Stores',
    canDeactivate: [manageStoresCanDeactivate],
    pathMatch: 'full',
  },
  {
    path: 'manage-stores/:id',
    data: { permission: 'StoreManager' },
    canActivate: [AuthGuard, administrationGuard],
    component: StoreDetailComponent,
    title: 'Rediger butik',
    canDeactivate: [storeDetailCanDeactivate],
    pathMatch: 'full',
  },
  {
    path: 'manage-users',
    data: { permission: 'UserManager' },
    canActivate: [AuthGuard, administrationGuard],
    component: ManageUsersComponent,
    title: 'Administrer brugere',
    canDeactivate: [manageUsersCanDeactivate],
    pathMatch: 'full',
  },
  {
    path: 'lookup-member',
    data: { permission: 'SendoutManager' },
    canActivate: [AuthGuard, administrationGuard],
    component: MemberLookupPageComponent,
    title: 'Medlemsopslag',
    pathMatch: 'full',
  },
  {
    path: '**',
    component: NotFoundPageComponent,
    title: 'Not found',
  },
];
